import { Icon } from "../../../components";
import { com } from "../../../proto/game.pb";
import { Image, TableCell, TableRow, Typography } from "../../ui";
import { formatDate } from "../../utils/formatDate";
import { getScoreColor } from "../../utils/get-score-color";
import css from "./RoundsEntry.module.scss";

type Entry = com.achlid.crash.game.stateless.ITopRoundEntry;

export const RoundsEntry = ({ entry }: { entry: Entry }) => {
  return (
    <TableRow className={css.row}>
      <TableCell className={css.cell}>
        <div className={css.date}>
          <Icon name="calendar" width={20} height={20} color="#545454" />
          <Typography
            className={css.dateText}
            variant="caption2"
            color="grey-black"
          >
            {formatDate(entry.timestamp)}
          </Typography>
        </div>
      </TableCell>
      <TableCell className={css.cell}>
        <Typography
          variant="caption1"
          color={getScoreColor(entry?.crashPoint as any)}
        >
          {entry.crashPoint?.toFixed(2)}
        </Typography>
      </TableCell>
      <TableCell className={css.cell}>
        <Image
          className={css.shieldIcon}
          classNameBody={css.shieldIcon}
          src="shield.png"
          variant="base"
        />
      </TableCell>
    </TableRow>
  );
};
